var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2.685 10.834 14.01-5.525c1.016-.398 2.01.597 1.613 1.613l-5.524 14.01c-.42 1.083-2.033 1.016-2.365-.11l-1.303-4.398a.86.86 0 0 1 .154-.818l3.403-4.375c.066-.066.066-.199-.022-.287a.2.2 0 0 0-.265 0L8.01 14.347c-.266.177-.553.243-.818.155l-4.397-1.304c-1.127-.332-1.193-1.945-.11-2.364"
  })));
};
export default SvgSend;